// extracted by mini-css-extract-plugin
export var button = "_99-0";
export var icon = "_99-1";